'use client';
import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { Star, BookOpen, UserPlus, CheckCircle, Camera, Award, Shield, Cake } from 'lucide-react';
import { toast } from 'sonner';

const BADGES = [
{ icon: Cake, label: 'Birthday Verified', color: 'text-pink-500' },
{ icon: Camera, label: 'Photo Verified', color: 'text-blue-500' },
{ icon: Award, label: 'Achievement Verified', color: 'text-amber-500' },
{ icon: Shield, label: 'Family Verified', color: 'text-green-500' }];


export default function DogProfileHero() {
  const [pawCount, setPawCount] = useState(2847);
  const [celebrateCount, setCelebrateCount] = useState(1203);
  const [following, setFollowing] = useState(false);
  const [pawGiven, setPawGiven] = useState(false);

  const handleGivePaw = () => {
    if (!pawGiven) {
      setPawCount((p) => p + 1);
      setPawGiven(true);
      toast?.success('🐾 Paw given to Biscuit!');
    }
  };

  const handleCelebrate = () => {
    setCelebrateCount((c) => c + 1);
    toast?.success('🎉 You celebrated Biscuit!');
  };

  const handleFollow = () => {
    setFollowing((f) => !f);
    toast?.success(following ? 'Unfollowed Biscuit' : '❤️ Now following Biscuit!');
  };

  return (
    <div className="relative">
      {/* Cover photo */}
      <div className="w-full h-64 md:h-80 overflow-hidden bg-gradient-to-br from-violet-100 to-amber-50">
        <AppImage
          src="https://images.unsplash.com/photo-1728843737593-b339127a7779"
          alt="Golden retriever Biscuit running through autumn leaves in a sunny park"
          fill
          className="object-cover opacity-80"
          priority />
        
        <div className="absolute inset-0 bg-gradient-to-t from-foreground/30 to-transparent" />
      </div>
      {/* Profile card */}
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10">
        <div className="relative -mt-20 pb-6">
          <div className="flex flex-col md:flex-row md:items-end gap-6">
            {/* Avatar */}
            <div className="relative shrink-0">
              <div className="w-36 h-36 rounded-2xl border-4 border-card overflow-hidden shadow-elevated bg-muted">
                <AppImage
                  src="https://images.unsplash.com/photo-1711337827244-4a37be9a3236"
                  alt="Biscuit the golden retriever, smiling with tongue out against autumn background"
                  width={144}
                  height={144}
                  className="object-cover w-full h-full"
                  priority />
                
              </div>
              <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-success rounded-full border-2 border-card flex items-center justify-center">
                <CheckCircle size={16} className="text-white" />
              </div>
            </div>

            {/* Name + meta */}
            <div className="flex-1 min-w-0 mt-4 md:mt-0 md:pb-2">
              <div className="flex flex-wrap items-center gap-2 mb-1">
                <h1 className="text-3xl font-800 text-foreground tracking-tight">Biscuit</h1>
                <span className="px-2.5 py-0.5 bg-amber-50 text-amber-700 border border-amber-200 rounded-full text-xs font-700">
                  🏅 Founding Dog
                </span>
              </div>
              <p className="text-base text-muted-foreground font-500 mb-2">Golden Retriever · 7 years of memories</p>
              <div className="flex flex-wrap gap-2 mb-3">
                {BADGES?.map((b) =>
                <span key={`badge-${b?.label}`} className="flex items-center gap-1 text-xs font-600 text-muted-foreground bg-muted px-2 py-1 rounded-full border border-border">
                    <b.icon size={11} className={b?.color} />
                    {b?.label}
                  </span>
                )}
              </div>
              <p className="text-sm text-muted-foreground">Owned by <span className="font-600 text-foreground">Sarah Reynolds</span></p>
            </div>

            {/* Action buttons */}
            <div className="flex flex-wrap gap-2 md:pb-2 shrink-0">
              <button
                onClick={handleGivePaw}
                disabled={pawGiven}
                className={`paw-btn flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-700 border transition-all
                  ${pawGiven ?
                'bg-primary/10 text-primary border-primary/20 cursor-not-allowed' : 'bg-primary text-primary-foreground border-primary hover:bg-secondary-foreground'}`}>
                
                <span>🐾</span>
                <span>{pawGiven ? 'Paw Given!' : 'Give Paw'}</span>
                <span className="font-tabular text-xs opacity-80">{pawCount?.toLocaleString()}</span>
              </button>
              <button
                onClick={handleCelebrate}
                className="paw-btn flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-700 bg-amber-50 text-amber-700 border border-amber-200 hover:bg-amber-100 transition-all">
                
                <Star size={15} />
                <span>Celebrate</span>
                <span className="font-tabular text-xs opacity-70">{celebrateCount?.toLocaleString()}</span>
              </button>
              <button className="paw-btn flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-700 bg-card border border-border text-foreground hover:bg-muted transition-all">
                <BookOpen size={15} />
                <span>Sign Guestbook</span>
              </button>
              <button
                onClick={handleFollow}
                className={`paw-btn flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-700 border transition-all
                  ${following ?
                'bg-secondary text-primary border-primary/20' : 'bg-card border-border text-foreground hover:bg-muted'}`}>
                
                <UserPlus size={15} />
                <span>{following ? 'Following' : 'Follow'}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>);



}